"use client";
import { createTheme } from "@mui/material/styles";
import { createBaseComponents } from "@theme/shared/create-base-components.jsx";

const muiTheme = createTheme();

export const createComponents = () =>
  createBaseComponents({
    buttonRadius: "12px",
    cardRadius: 20,
    filledBorderWidth: 1,
    textFieldOverrides: {
      root: {
        "& .MuiInputBase-root.MuiInput-root:hover:not(.Mui-disabled, .Mui-error):before":
          {
            borderBottom: `1px solid ${muiTheme.palette.divider}`,
            animation: "none",
            transition: "none",
          },
      },
    },
  });
